import { LOCALES } from 'i18n/locales';

export const workpackExportOptionsIntl = {
    [LOCALES.ENGLISH]: {
        'workpackExportOptions.workpackOrientation.label': 'Paper size and orientation',
        'workpackExportOptions.workpackScale.label': 'Scale',
        'workpackExportOptions.paperOrientation.label': 'Paper orientation',
        'workpackExportOptions.paperSize.label': 'Paper size',
        'workpackExportOptions.mapScale.label': 'Map scale'
    },
    [LOCALES.WELSH]: {
        'workpackExportOptions.workpackOrientation.label': '[Paper size and orientation]',
        'workpackExportOptions.workpackScale.label': '[Scale]',
        'workpackExportOptions.paperOrientation.label': '[Paper orientation]',
        'workpackExportOptions.paperSize.label': '[Paper size]',
        'workpackExportOptions.mapScale.label': '[Map scale]'
    }
};
